import { render, staticRenderFns } from "./ViewTable.vue?vue&type=template&id=b596dfec&scoped=true"
import script from "./ViewTable.vue?vue&type=script&lang=js"
export * from "./ViewTable.vue?vue&type=script&lang=js"
import style0 from "./ViewTable.vue?vue&type=style&index=0&id=b596dfec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b596dfec",
  null
  
)

export default component.exports